import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SpeakerSimpleSlash } from "@phosphor-icons/react";
import { isFeedMuted, subscribeFeedMute, unmuteFeedNow } from "@/components/FeedItem";

const FEED_PATHS = ["/", "/feed"];

export function SoundChip({ testId = "feed-sound-chip" }) {
  const { pathname } = useLocation();
  const [muted, setMuted] = useState(isFeedMuted());
  useEffect(() => subscribeFeedMute(setMuted), []);

  if (!muted || !FEED_PATHS.includes(pathname)) return null;
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={unmuteFeedNow}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-sky-500 text-white text-[11px] font-heading font-black ring-1 ring-sky-300/60 shadow-[0_0_14px_-2px_rgba(56,189,248,0.8)] animate-pulse"
      aria-label="Tap for sound"
    >
      <SpeakerSimpleSlash size={11} weight="fill" /> Tap for sound
    </button>
  );
}
